module.exports = __webpack_public_path__ + "static/img/cerfity-model.259d8eb3.png";